import { render, staticRenderFns } from "./homeTrain.vue?vue&type=template&id=1cd04d70&scoped=true"
import script from "./homeTrain.vue?vue&type=script&lang=js"
export * from "./homeTrain.vue?vue&type=script&lang=js"
import style0 from "./homeTrain.vue?vue&type=style&index=0&id=1cd04d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd04d70",
  null
  
)

export default component.exports